import React, { useState } from 'react';
import { Hero, Mission, WhoWeServe, ValuePillars, Quote, Footer, Facilitators } from './components/Sections';
import { Pricing } from './components/Pricing';
import { CheckoutModal } from './components/CheckoutModal';
import { SuccessView } from './components/SuccessView';
import { Header } from './components/Header';
type ViewState = 'landing' | 'success';
export function App() {
  const [view, setViewState] = useState<ViewState>('landing');
  const [selectedTier, setSelectedTier] = useState<any | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transactionRef, setTransactionRef] = useState('');
  const handleSelectTier = (tier: any) => {
    setSelectedTier(tier);
    setIsModalOpen(true);
  };
  const handlePaymentSuccess = (reference: string) => {
    setTransactionRef(reference);
    setIsModalOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    setViewState('success');
  };
  const handleReset = () => {
    setViewState('landing');
    setSelectedTier(null);
    setTransactionRef('');
  };
  if (view === 'success') {
    return <SuccessView tierName={selectedTier?.name || 'Membership'} reference={transactionRef} onReset={handleReset} data-id="element-0" />;
  }
  return <div className="min-h-screen bg-cream selection:bg-forest selection:text-cream" data-id="element-1">
      <Header data-id="element-2" />
      <Hero data-id="element-3" />
      <Facilitators data-id="element-4" />
      <Mission data-id="element-5" />
      <WhoWeServe data-id="element-6" />
      <ValuePillars data-id="element-7" />
      <Pricing onSelectTier={handleSelectTier} data-id="element-8" />
      <Quote data-id="element-9" />
      <Footer data-id="element-10" />

      {/* Only mount the checkout modal (and its Paystack script) once the user opens it */}
      {isModalOpen && selectedTier && <CheckoutModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSuccess={handlePaymentSuccess} tier={selectedTier} data-id="element-11" />}
    </div>;
}